module.exports = __webpack_public_path__ + "img/form.80703570.svg";